/*rutas de invoice*/
// import Invoices from '@/apps/billing/views/Invoices';
import Invoices from '@/apps/billing/views/invoice/';
// import InvoicesNew from '@/apps/billing/views/InvoicesNew';
import InvoicesNew from '@/apps/billing/views/invoice/InvoForm';
export default [
  {
  	path: 'invoices',
  	name: 'Invoices',
    folder: Invoices,
  },
  {
    path: 'invoices/new',
    name: 'InvoicesNew',
    folder: InvoicesNew,
  },
	{
	  path: 'edit-invoice/:idinv',
	  name: 'InvoiceEdit',
    folder: InvoicesNew,
	},
	{
	  path: 'invoice/:idc/:transac',
	  name: 'InvoiceNewTransac',
    folder: InvoicesNew,
	},
	{
	  path: 'duplicate-invoice/:idinv',
	  name: 'InvoiceDuplicate',
    folder: InvoicesNew,
	},
  {
    path: 'convert-est-to-inv/:idest',
    name: 'estConvertInvoice',
    folder: InvoicesNew,
  },
  {
    path: 'invoice-pro-for-customer/:idc',
    name: 'InvoProFormcustomerID',
    folder: InvoicesNew,
  }
];
